"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetroUser = isMetroUser;
exports.isAdmin = isAdmin;
exports.isOperator = isOperator;
exports.isUserCompany = isUserCompany;
var env_1 = require("../env");
var intefaces_1 = require("../interfaces/intefaces");
function isMetroUser(user) {
    if (!user || !user.company)
        return false;
    return user.company.id === env_1.metroCompanyId;
}
function isAdmin(user) {
    if (!user || !user.role)
        return false;
    return user.role == intefaces_1.UserRole.ADMIN;
}
function isOperator(user) {
    if (!user || !user.role)
        return false;
    return user.role == intefaces_1.UserRole.OPERATOR;
}
function isUserCompany(user, company) {
    if (!user || !user.company)
        return false;
    return user.company.id === company.id;
}
